import React from 'react';

import { useDeleteMainBudgetPlanning } from 'scenes/MainBudgetPlanning/data';

import { Actions } from './Actions';

export const MainBudgetPlanningActions = ({
  data,
  onDelete,
  onEdit,
  limit,
}) => {
  const [deleteMainBudgetPlanning] = useDeleteMainBudgetPlanning();

  const handleDelete = async () => {
    await deleteMainBudgetPlanning(data);
    onDelete?.(data);
  };

  const handleEdit = () => onEdit?.(data);
  return <Actions onDelete={handleDelete} onEdit={handleEdit} limit={limit} />;
};

export default MainBudgetPlanningActions;
